<app-page-layout
  [title]="title"
  [subtitle]="subtitle"
  [heroImage]="heroImage"
  [breadcrumbs]="breadcrumbs"
  [prevPage]="prevPage"
  [nextPage]="nextPage">

  <div class="page-section intro">
    <h2>Toutes nos Solutions d'Assurance</h2>
    <p>
      Chez Brokins, nous proposons une gamme complète d'assurances pour protéger ce qui compte le plus 
      pour vous : votre santé, vos biens, votre activité professionnelle et votre avenir. Découvrez ci-dessous 
      l'ensemble de nos solutions classées par catégorie.
    </p>
    <p>
      Nos experts comparent pour vous les meilleures offres du marché et vous accompagnent dans le choix 
      de la protection la plus adaptée à vos besoins.
    </p>
  </div>

  <!-- Grille de toutes les catégories -->
  <div class="categories-grid">
    <div class="category-card" *ngFor="let category of assuranceCategories" [style.border-top-color]="category.color">
      <div class="category-header">
        <span class="category-icon">{{ category.icon }}</span>
        <h3 [style.color]="category.color">{{ category.title }}</h3>
      </div>
      
      <ul class="assurance-list">
        <li *ngFor="let assurance of category.assurances">
          <a [routerLink]="assurance.link" [style.color]="category.color">
            <span class="arrow">→</span>
            {{ assurance.name }}
          </a>
        </li>
      </ul>
    </div>
  </div>

  <!-- Section statistiques -->
  <div class="stats-section">
    <div class="stat-card">
      <div class="stat-number">45+</div>
      <div class="stat-label">Solutions d'assurance</div>
    </div>
    <div class="stat-card">
      <div class="stat-number">50+</div>
      <div class="stat-label">Partenaires assureurs</div>
    </div>
    <div class="stat-card">
      <div class="stat-number">10 000+</div>
      <div class="stat-label">Clients satisfaits</div>
    </div>
    <div class="stat-card">
      <div class="stat-number">24/7</div>
      <div class="stat-label">Support disponible</div>
    </div>
  </div>

  <!-- Section avantages -->
  <div class="page-section">
    <h2>Pourquoi Choisir Brokins ?</h2>
    <div class="guarantees-grid">
      <div class="guarantee-card">
        <h3>Comparaison Exhaustive</h3>
        <p>
          Nous comparons les offres de plus de 50 assureurs partenaires pour vous garantir 
          le meilleur rapport qualité-prix du marché.
        </p>
      </div>

      <div class="guarantee-card">
        <h3>Accompagnement Personnalisé</h3>
        <p>
          Nos conseillers experts vous guident dans vos choix et vous accompagnent tout au long 
          de la vie de vos contrats.
        </p>
      </div>

      <div class="guarantee-card">
        <h3>Devis Gratuits et Rapides</h3>
        <p>
          Obtenez vos devis en quelques minutes, sans engagement et sans frais cachés. 
          Comparaison 100% gratuite.
        </p>
      </div>

      <div class="guarantee-card">
        <h3>Expertise Métier</h3>
        <p>
          Plus de 15 ans d'expérience dans le courtage en assurance. Nous connaissons les 
          spécificités de chaque secteur.
        </p>
      </div>

      <div class="guarantee-card">
        <h3>Gestion Simplifiée</h3>
        <p>
          Un seul interlocuteur pour tous vos contrats. Nous gérons vos sinistres et résiliations 
          en toute transparence.
        </p>
      </div>

      <div class="guarantee-card">
        <h3>Indépendance Totale</h3>
        <p>
          En tant que courtier indépendant, nous travaillons uniquement dans votre intérêt, 
          sans priorité d'assureur.
        </p>
      </div>
    </div>
  </div>

  <!-- Section besoin spécifique -->
  <div class="info-box">
    <p>
      <strong>Besoin d'une assurance spécifique non listée ?</strong> Contactez-nous ! 
      Grâce à notre réseau de partenaires, nous pouvons répondre à tous vos besoins en assurance, 
      même les plus spécifiques.
    </p>
  </div>

  <!-- CTA finale -->
  <div class="cta-box">
    <h3>Prêt à Trouver Votre Assurance Idéale ?</h3>
    <p>Comparez gratuitement les meilleures offres du marché en quelques clics</p>
    <button class="btn-cta" (click)="navigateToComparison()">Lancer ma comparaison</button>
  </div>

</app-page-layout>
